<template>
  <div class="container-fluid" v-if="permissao">
    <!-- box -->
    <div class="box box-default align-cabecalho">
      <a class="info-fechamento" @click="exibeInfoFechamento" id="info">Datas fechamento financeiro</a>
      <h2>SLA Gerencial </h2>
      <div class="cabecalho">
        <h4><strong> Selecione o SLA que deseja visualizar/preencher: </strong></h4>

        <!-- Select group contract SLA -->
        <div class="form-inline">
          <div class="row">
            <!-- Select Year -->
            <div class="form-group" al ign="right">
              <label class="lb-sla-gerencial" for="exampleInputName2">Ano:</label>
              <select class="form-control" v-model="ano_selecionado" @change="changeAno()"> 
                <option v-for="i in anos" v-bind:key="i.id">{{ i }}</option>
              </select>
            </div>

            <!-- Select State -->
            <div class="form-group">
              <label class="lb-sla-gerencial" for="exampleInputName2">Estado:</label>
              <select class="form-control" v-model="uf_selecionada" @change="limparContrato()">
                <option v-for="uf in ufs" :value='uf.id' v-bind:key="uf.id">{{ uf.nome }}</option>
              </select>
            </div>

            <!-- Select Contract -->
            <div class="form-group">
              <label class="lb-sla-gerencial" for="exampleInputName2">Contrato:</label>
              <select class="form-control " align="center" v-model="contrato_selecionado" @change="changeContrato();">
                <option value='-- Selecionar Contrato --' disabled>-- Selecionar Contrato --</option>
                <option v-for="i in tipo_imovel_servicos" :value='i' v-bind:key="i.id">{{ i.nome }}</option>
              </select>
            </div>

            <div class="form-group">
              <label class="lb-sla-gerencial" for="exampleInputName2">Fornecedor:</label>
              <select class="form-control " align="center" v-model="fornecedor_selecionado" @change="changeFornecedor()">
                <option value='-- Selecionar Fornecedor --' disabled>-- Selecionar Fornecedor --</option>
                <option v-for="i in fornecedores" :value='i' v-bind:key="i.id">{{ i.nome }} - #{{ (i.numero_contrato.length > 0) ? i.numero_contrato.substring(0, (i.numero_contrato.length - 2)) : '' }} </option>
              </select>
            </div>

            <!-- Select Proprietário -->
            <!-- <div class="form-group col-md-6">
              <label class="lb-sla-gerencial" for="exampleInputName2">Proprietário:</label>
              <select class="form-control " align="center" v-model="proprietario_selecionado" @change="onChangeContrato()">
                <option v-for="i in proprietarios" :value='i' >{{ i.nome }}</option>
              </select>
            </div> -->


            <!-- <div class="form-group" align="right">
              <input type="button" name="" value="Buscar">
            </div> -->
          </div>
        </div> <!-- ./form-inline -->
      </div>
    </div>

    <controle-apuracao-sla ref='controleApuracaoSla' :anoSelecionado="ano_selecionado" :semresultado="semresultado" />
  </div>
</template>
<script>
import controleApuracaoSla from './ControleApuracaoSla.vue'

export default {
  props: ['refresh_componentes'],
  data () {
    return {
      showModal: false,
      grupo: '',
      contratos: [],
      fornecedores: [],
      proprietarios: [],
      data_expiracao: '',
      ufs: [],
      anos: [],
      uf_selecionada: '',
      contrato_selecionado: '-- Selecionar Contrato --',
      fornecedor_selecionado: '-- Selecionar Fornecedor --',
      proprietario_selecionado: '',
      ano_selecionado: new Date().getFullYear(),
      tipo_imovel_servicos: '',
      env: process.env,
      gruposPermitidos: ['oi', 'admin', 'adminVTAL'],
      permissao: true,
      semresultado: 1,
      // anoatual: null
    }
  },
  mounted: function () {
    // setando o ano atual
    // let dat = new Date()
    // this.anoatual = dat.getUTCFullYear()
    // Array com grupos do usuário
    let usuarioGrupo = this.$store.state.login.loginUsuario.grupo
    // console.warn('ug', usuarioGrupo)
    // msg(setPermissaoNegada) - função verificando se o usuário possui mais de um grupo(max 3)
    let msgGrupos = usuarioGrupo[0].nome
    if (usuarioGrupo[1]) {
      msgGrupos = usuarioGrupo[0].nome + ' ,' + usuarioGrupo[1].nome
      if (usuarioGrupo[2]) {
        msgGrupos = usuarioGrupo[0].nome + ' ,' + usuarioGrupo[1].nome + ' ,' + usuarioGrupo[2].nome
      }
    }
    console.log(msgGrupos)
    // if (this.gruposPermitidos.indexOf(usuarioGrupo) === -1) {
    if (usuarioGrupo.find(permissao => permissao.nome === 'oi' || permissao.nome === 'admin' || permissao.nome === 'adminVTAL')) {
      setTimeout(() => {
        vm.getUfsDoUsuario()
        vm.getAno()
        vm.getContratosPorUf()
        vm.getTipoImovelServico()
        vm.changeAno()
      }, 100)
      let vm = this
      if (this.$store.state.alertAtualizacoes.alertAtualizacoes.status === false && this.$store.state.alertAtualizacoes.alertAtualizacoes.status === false) {
        // vm.$store.commit('setAlertAtualizacoes', {status: true, show: true})
      }
    }
  },
  watch: {
    refresh_componentes: function () {
      this.changeContrato()
    }
  },
  methods: {
    modalll () {
      this.$store.commit('setAlert', {msg: `Preencha todos os campos corretamente`, status: false, show: true})
    },
    getUfsDoUsuario () {
      this.ufs = this.$store.state.login.loginUsuario.estado
    },
    getAno () {
      let anoatual = new Date().getUTCFullYear()
      for (let i = anoatual; i >= 2023; i--) {
        this.anos.push(i)
      }
      
      // let vm = this
      // this.$axios.get(`${this.env.FINANCEIRO.SLA}/getano`, {
      //   headers: {
      //     'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
      //   }
      // })
      // .then(function (response) {
      //   vm.anos = response.data
      // })
    },
    getContratosPorUf () {
      let vm = this
      this.$axios.post(`${this.env.FINANCEIRO.SLA}/getcontratosporuf`, vm.ufs, {
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
        }
      })
      .then(function (response) {
        vm.contratos = response.data
      })
    },
    getFornecedorContrato (ano, uf, tipoImovelServico) {
      let vm = this
      vm.fornecedores = []
      vm.fornecedor_selecionado = '-- Selecionar Fornecedor --'
      vm.$store.commit('setDadosFornecedor', null)
      this.$axios.post(`${this.env.FINANCEIRO.SLA}/getfornecedorcontratosuf`, {ano, uf, tipoImovelServico}, {
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
        }
      })
      .then(function (response) {
        vm.fornecedores = response.data
        if (vm.fornecedores.length > 1) {
          vm.semresultado = null
        } else if (vm.fornecedores.length === 1) {
          vm.fornecedor_selecionado = vm.fornecedores[0]
          vm.$store.commit('setDadosFornecedor', vm.fornecedor_selecionado)
          vm.changeFornecedor()
        } else if (vm.fornecedores.length === 0) {
          // limpar contrato se não houver fornecedor?
          vm.semresultado = 1
        }
      })
    },
    getProprietario () {
      let vm = this
      this.$axios.post(`${this.env.FINANCEIRO.SLA}/getproprietariosuf`, vm.ufs, {
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
        }
      })
      .then(function (response) {
        vm.proprietarios = response.data
      })
    },
    getTipoImovelServico () {
      let vm = this
      this.$axios.get(`${this.env.FINANCEIRO.SLA}/gettipoimovelservico`, {
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
        }
      })
      .then(function (response) {
        vm.tipo_imovel_servicos = response.data.filter(el => [1, 2, 3, 4, 7, 8].includes(el.id))
      })
    },
    limparContrato () {
      let vm = this
      vm.contrato_selecionado = '-- Selecionar Contrato --'
      vm.semresultado = null
      vm.fornecedor_selecionado = this.fornecedor_default
      vm.$store.commit('setContrato', 0)
      vm.$store.commit('setDadosFornecedor', '')
    },
    changeFornecedor () {
      let vm = this
      vm.$store.commit('setDadosFornecedor', vm.fornecedor_selecionado)
      if (vm.uf_selecionada !== '' && vm.contrato_selecionado !== '-- Selecionar Contrato --' && (vm.fornecedor_selecionado !== '-- Selecionar Fornecedor --')) {
        vm.$refs.controleApuracaoSla.getSla(vm.uf_selecionada, vm.contrato_selecionado, vm.fornecedor_selecionado, vm.ano_selecionado)
      }
    },
    changeContrato () {
      let vm = this
      vm.semresultado = null
      vm.$store.commit('setDadosFornecedor', '')
      vm.$store.commit('setInfoContrato', '')
      vm.$store.commit('setInfoContrato', vm.contrato_selecionado)
      vm.$store.commit('setUfContratoSelecionado', {ufSelecionada: vm.uf_selecionada, contratoSelecionado: vm.contrato_selecionado})
      vm.getFornecedorContrato(vm.ano_selecionado, vm.uf_selecionada, vm.contrato_selecionado)
    },
    changeAno () {
      this.$store.commit('setAno', this.ano_selecionado)
      // this.changeFornecedor()
    },
    exibeInfoFechamento: function () {
      this.$store.commit('setAlertCalendario', {status: true, show: true})
    }
  },
  components: {
    'controle-apuracao-sla': controleApuracaoSla
  }
}
</script>

<style scoped>
.form-group label {
  margin-right: 0.5em !important;
  display: block !important;
}
.form-inline {
  padding: 1em;
}
.align-cabecalho {
  padding: 10px;
}
.cabecalho {
  margin-top: 15px;
  background-color: #dbdeec;
  padding: 1em;
  border-radius: 0.5em;
}
.label-cabecalho {
  margin-top: 20px;
}
.label-cabecalho label {
  text-align: right;
  margin-top: 5px;
}
.btn-planilha-resumo-geral {
  margin: 5%;
}
.info-fechamento {
  float: right;
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// ListarSla.vue?08d1efde